var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SBIcon',{staticClass:"delivery-status",class:{ 'up-1': _vm.status === 'sending' },attrs:{"icon":_vm.statusIcon.icon,"color":_vm.statusIcon.color,"size":_vm.statusIcon.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }